export default [
  { label: '受注確定', value: 'orders' },
  { label: '受注前', value: 'orders_before' },
]
